import React, { useState } from "react";
import "./expenseHeader.css";
import { PosCustomButton } from "../../../../../customComponents/PosCustomButton/PosCustomButton";
import { PlusIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import AddExpenseModal from "../AddExpenseModal";
import { createSessionExpense } from "../../../../../config/Services";

const ExpenseHeader = () => {
  const [openNewExpense, setOpenNewExpense] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [formData, setFormData] = useState({
    expenseTitle: "",
    amount: "",
    reason: "",
  });
  const [loader, setLoader] = useState(false);
  const showAlert = useSnackbar();

  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));

  const handleClose = () => {
    setOpenNewExpense(false);
    // Reset form on close
    setFormData({
      expenseTitle: "",
      amount: "",
      reason: "",
      ledger: {},
    });
    setUploadedFile(null);
  };

  const validatePayload = (payload) => {
    if (!payload?.organizationId) {
      showAlert("Select Company", "warning");
      return false;
    }
    if (!payload?.locationId) {
      showAlert("Select Location", "warning");
      return false;
    }
    if (!payload?.voucherEntryName) {
      showAlert("Enter expense title", "warning");
      return false;
    }

    if (!formData?.amount) {
      showAlert("Please enter total amount", "warning");
      return false;
    }

    // if (!formData?.ledger || Object.keys(formData?.ledger)?.length === 0) {
    //   showAlert("Select Expense Account", "warning");
    //   return false;
    // }

    return true;
  };

  const handleCreateExpense = async () => {
    setLoader(true);
    const payload = {
      locationId: locId || "",
      organizationId: orgId || "",
      posSessionId: sessionId,
      voucherDate: format(new Date(), "yyyy-MM-dd"),
      voucherMasterId: "VM0000007",
      voucherEntryName: formData?.expenseTitle,
      isRecurring: false,
      recurringFrequency: "NONE",
      currencyId: "CUR000002",
      description: formData?.reason || "",
      voucherParticularRequests: [
        {
          ledgerId: "LED000041",
          isDebit: true,
          entryType: "EXPENSE",
          amount: Number(formData?.amount) || 0,
        },
        {
          ledgerId: "LED000046",
          masterBankFacilityId: null,
          isDebit: false,
          entryType: "PAID_THROUGH",
          amount: Number(formData?.amount) || 0,
        },
      ],
      properties: [],
      documents:
        uploadedFile && Object.keys(uploadedFile).length > 0
          ? [{ name: uploadedFile?.name, url: uploadedFile?.url }]
          : [],
      createdBy: retailUserLocalStorageData?.uidx,
      createdByName: retailUserLocalStorageData?.firstName,
      isRecurrenceEndless: false,
      recurrenceStartDate: "",
      recurrenceEndDate: null,
      isNotify: false,
      notificationDate: 0,
      plusmaxReferenceId: 0,
      billDueDate: null,
      billCreationDate: null,
      isQualifiedTax: false,
      mappedType: "NONE",
      isBillable: false,
      vendorName: null,
      plusmaxReferenceName: "",
    };

    const isValidated = validatePayload(payload);
    if (!isValidated) {
      setLoader(false);
      return;
    }

    createSessionExpense(payload)
      .then((res) => {
        if (res?.data?.data?.es === 1) {
          showAlert(res?.data?.data?.message || "Error while creating an expense", "error");
        } else if (res?.data?.status === "ERROR") {
          showAlert("Error while creating an expense", "error");
        } else {
          showAlert("Expense Created Succesfully", "success");
          const customEvent = new CustomEvent("customEvent", {
            detail: { type: "expenseAdded" },
          });
          window.dispatchEvent(customEvent);

          handleClose();
        }
        setLoader(false);
      })
      .catch((err) => {
        showAlert(err?.message || "Error while creating an expense", "error");
      });
  };

  return (
    <div className="expenses-header">
      <button
        className="expenses-new-btn"
        onClick={() => setOpenNewExpense(true)}
        data-testid="button-open-add-expense"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-plus mr-2 h-4 w-4"
          aria-hidden="true"
          style={{ width: "16px", height: "16px", marginRight: "8px" }}
        >
          <path d="M5 12h14"></path>
          <path d="M12 5v14"></path>
        </svg>
        New Expense
      </button>
      <AddExpenseModal
        openNewExpense={openNewExpense}
        handleClose={handleClose}
        uploadedFile={uploadedFile}
        formData={formData}
        setFormData={setFormData}
        setUploadedFile={setUploadedFile}
        openUploadModal={openUploadModal}
        setOpenUploadModal={setOpenUploadModal}
        handleCreateExpense={handleCreateExpense}
        loader={loader}
      />
    </div>
  );
};

export default ExpenseHeader;
